// A regra da transcrição de áudio, do lado da tela: LIGADA a menos que a config diga
// `transcribe_audio: false`. Ausente ou nulo é ligada; só o `false` explícito desliga
// (02/10/2026, pedido do Murilo: transcrição por padrão para todos os agentes).
//
// É o espelho de `Messages::AudioTranscription.transcreve?`, no servidor, e mora num lugar só
// porque são dois leitores na tela — o interruptor da aba "Voz e anexos" e o microfone do
// Playground. Com uma leitura em cada um, o interruptor podia mostrar desligado o agente que o
// servidor transcreve, e o Playground esconder o microfone do rascunho que ouve.
export function transcreveAudio(config) {
  return (config || {}).transcribe_audio !== false;
}
